module.exports = __webpack_public_path__ + "static/img/advertising_phone.954d4b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adv/advertising_phone.png
// module id = xcXy
// module chunks = 1